import React from "react";
import { Badge, colors } from "../design/badge";
import { ProfessionalServiceType } from "../models/ProfessionalServiceType";

interface ProfessionalRoleBadgeProps {
  role: ProfessionalServiceType;
}

const ProfessionalRoleBadge: React.FC<ProfessionalRoleBadgeProps> = ({
  role,
}) => {
  let color;
  let title;

  switch (role) {
    case "attorney":
      color = "blue";
      title = "Attorney";
      break;
    case "divorce_coach":
      color = "green";
      title = "Divorce Coach";
      break;
    case "coparent_coach":
      color = "purple";
      title = "Co-Parenting Coach";
      break;
    default:
      color = "gray";
      title = role;
      break;
  }

  return <Badge color={color as keyof typeof colors}>{title}</Badge>;
};

export default ProfessionalRoleBadge;
